import { FatalDecoratorLimitClassError } from '@rehaje/reactive'
import {
  createClassDecorator,
  ensureProtoProps,
  isInheritProto
} from '@rehaje/shared'

import { TypedNode } from '../models/TypedNode'

import type { ScopeDeclaration } from '../types'
import type { InferClassDecorator, TClass } from '@rehaje/shared'

/**
 * 声明作用域的 TS 类装饰器，只能用于包装 TypedNode 子类
 * @example
 * ```
 * // jsdoc 限制，实际使用请将 * 替换为 @
 * *scope({
 *   type:"Block",
 *   variables:[
 *     {
 *       name:"aa",
 *       value:123
 *     }
 *   ]
 * })
 * class MyNode extends TypedNode {
 *   *fromNode()
 *   *reactive()
 *   test = 123
 * }
 * ```
 * @param declaration 作用域声明元信息
 */
export const scope: <T extends TClass>(
  declaration: ScopeDeclaration<T>
) => InferClassDecorator<T> = createClassDecorator({
  tsDecorator(constructor, declaration) {
    const proto: TypedNode = constructor.prototype
    if (!isInheritProto(proto, TypedNode.prototype)) {
      throw new FatalDecoratorLimitClassError('scope', 'TypedNode')
    }

    const scopeDeclaration = ensureProtoProps(proto, '__r_scope_declaration', {})
    scopeDeclaration.type = declaration.type ?? scopeDeclaration.type ?? 'Local'
    scopeDeclaration.variables = [
      ...(scopeDeclaration.variables ?? []),
      ...(declaration.variables ? [declaration.variables] : [])
    ]
  }
})
